import axios from 'axios';
import {backendHost} from '../../config';

export const getWithdrawalsById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/withdrawals/by-id`, {params});
};